import { BRAND } from '../brand';

interface MarkenlogoProps {
	kompakt?: boolean;
	className?: string;
}

/**
 * Codebasierte Wortmarke für App und Druck. Das kantige, offene Haus und der
 * integrierte Haken entsprechen der final gewählten Variante A. Der
 * Produktname bleibt ausschließlich in brand.ts; das Signet funktioniert
 * ohne Netz und ohne zusätzlich zu ladende Bilddatei.
 */
export function Markenlogo({ kompakt = false, className = '' }: MarkenlogoProps) {
	return (
		<div className={`markenlogo ${kompakt ? 'markenlogo--kompakt' : ''} ${className}`.trim()}>
			<svg className="markenlogo-signet" viewBox="0 0 64 64" aria-hidden="true">
				<path className="markenlogo-zeichen" d="M10 54V26L32 8l18 17M10 54h17M51 43v11h-7" />
				<path className="markenlogo-zeichen" d="m25 39 11 11 21-21" />
			</svg>
			<div className="markenlogo-text">
				<strong>{BRAND.name}</strong>
				{!kompakt && <span>{BRAND.claim}</span>}
			</div>
		</div>
	);
}
